import { get } from 'lodash';

const readDataPropsContent = () => {
  return JSON.parse(
    get(
      document.getElementById('data-props'),
      'innerHTML',
      '{}'
    )
  );
};

const DataPropsContent = readDataPropsContent();

export default DataPropsContent;
